import { IDIService } from "../../IDIService";
import { Status } from "../../DataFrame";
import { ResponseResult } from "../FieldChangeResult";

export interface IConfigBackupService extends IDIService {
	IsSupported(): Promise<boolean>;
	GetBackupsAsync(): Promise<ControllerBackupConfigurationEntry[] | Status>;
	CreateBackupAsync(): Promise<CreateBackupResponse | ResponseResult<ConfigBackupCreateResult>>;
	RestoreBackupAsync(configurationId: string): Promise<ResponseResult<ConfigBackupRestoreResult>>;
	RestoreLatestBackupAsync(): Promise<ResponseResult<ConfigBackupRestoreResult>>;
}

export interface ControllerBackupConfigurationEntry {
	ConfigurationId: string;
	SoftwareVersion?: string;
	ExecutionDate?: string;
	BackupFileText?: string;
}

export interface CreateBackupResponse {
	ConfigurationId: string;
}

export enum ConfigBackupCreateResult {
	ResourceIsNotAvailable = -2,
	BackupCreationFailed = -1,
	UnknownError = 0,
	Created = 1,
}

export enum ConfigBackupRestoreResult {
	ResourceIsNotAvailable = -4,
	BackupNotFound = -3,
	WrongBackupData = -2,
	RestoreFailed = -1,
	UnknownError = 0,
	Restored = 1,
}